var rgbaRegex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/ig;
export function rgb2hsl(ri, gi, bi) {
    var r = ri / 255;
    var g = gi / 255;
    var b = bi / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h = (max + min) / 2;
    var s = h;
    var l = s;
    if (max === min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return { h: h, s: s, l: l };
}
function hue2rgb(p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
export function hsl2rgb(h, s, l) {
    var r = 0;
    var g = 0;
    var b = 0;
    if (s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return { r: r * 255, g: g * 255, b: b * 255 };
}
export function rgb2hsv(ri, gi, bi) {
    var r = ri / 255;
    var g = gi / 255;
    var b = bi / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h = max;
    var s = max;
    var v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max === min) {
        h = 0; // achromatic
    }
    else {
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}
export function hsv2rgb(h, s, v) {
    var r = 0;
    var g = 0;
    var b = 0;
    var i = Math.floor(h * 6);
    var f = h * 6 - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0:
            r = v;
            g = t;
            b = p;
            break;
        case 1:
            r = q;
            g = v;
            b = p;
            break;
        case 2:
            r = p;
            g = v;
            b = t;
            break;
        case 3:
            r = p;
            g = q;
            b = v;
            break;
        case 4:
            r = t;
            g = p;
            b = v;
            break;
        case 5:
            r = v;
            g = p;
            b = q;
            break;
    }
    return { r: r * 255, g: g * 255, b: b * 255 };
}
var fadeRegex = /fade\s*\(\s*'([^']+)'\s*,\s*(\d{1,3})%\s*\)/g;
var saturationRegex = /saturation\s*\(\s*'([^']+)'\s*,\s*([0|1]\.\d{1,10})\s*\)/g;
var lightenRegex = /lighten\s*\(\s*'([^']+)'\s*,\s*(\d{1,3})%\s*\)/g;
export function getColor(p, color) {
    var fr = fadeRegex.exec(color);
    var sr = saturationRegex.exec(color);
    var dr = lightenRegex.exec(color);
    if (fr) {
        var toRet = fadeColor(p, fr[1], parseInt(fr[2]));
        return toRet;
    }
    if (sr) {
        var toRet = saturationColor(p, sr[1], parseFloat(sr[2]));
        return toRet;
    }
    if (dr) {
        var toRet = lightenColor(p, dr[1], parseInt(dr[2]));
        return toRet;
    }
    if (color.startsWith("@")) {
        var name_1 = color.substr(1);
        if (p.theme.colors[name_1])
            return getColor(p, p.theme.colors[name_1]);
        else {
            console.error("invalid theme: color not found with name \"" + name_1 + "\"");
            return "#000";
        }
    }
    return color;
}
export function toRGBA(p, color) {
    var c = getColor(p, color);
    var r = 0;
    var g = 0;
    var b = 0;
    var a = 0;
    if (c.startsWith("#")) {
        switch (c.length) {
            case 4:
                r = parseInt(c[1], 16) / 15.0 * 255.0;
                g = parseInt(c[2], 16) / 15.0 * 255.0;
                b = parseInt(c[3], 16) / 15.0 * 255.0;
                a = 1.0;
                break;
            case 7:
                r = parseInt(c.substr(1, 2), 16);
                g = parseInt(c.substr(3, 2), 16);
                b = parseInt(c.substr(5, 2), 16);
                a = 1.0;
                break;
            case 9:
                r = parseInt(c.substr(1, 2), 16);
                g = parseInt(c.substr(3, 2), 16);
                b = parseInt(c.substr(5, 2), 16);
                a = parseInt(c.substr(7, 2), 16) / 255.0;
                break;
        }
    }
    else {
        var m = rgbaRegex.exec(c);
        if (m) {
            r = parseInt(m[1]);
            g = parseInt(m[2]);
            b = parseInt(m[3]);
            a = m[4] ? parseInt(m[4]) : 1.0;
        }
    }
    return { r: r, g: g, b: b, a: a };
}
export function fadeColor(p, color, percentage) {
    var col = toRGBA(p, color);
    return "rgba(" + col.r + ", " + col.g + ", " + col.b + ", " + col.a * percentage / 100.0 + ")";
}
export function saturationColor(p, color, satFactor) {
    var col = toRGBA(p, color);
    var hsv = rgb2hsv(col.r, col.g, col.b);
    var rgb = hsv2rgb(hsv.h, Math.min(1.0, hsv.s * satFactor), hsv.v ? hsv.v : 0);
    return ("rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + col.a + ")");
}
export function lightenColor(p, color, darkPercentage) {
    var col = toRGBA(p, color);
    var hsl = rgb2hsl(col.r, col.g, col.b);
    var l = hsl.l * darkPercentage / 100.0;
    var rgb = hsl2rgb(hsl.h, hsl.s, Math.max(0.0, Math.min(100.0, l)));
    return ("rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + col.a + ")");
}
//# sourceMappingURL=ColorHelpers.js.map